import equals from 'fast-deep-equal';
export default equals;
//# sourceMappingURL=deepEquals.js.map